<app-page-heading [title]="formTitle" [subheadingIcon]="'fa fa-user-plus'"></app-page-heading>

<app-user-form #userForm [user]="user" [mode]="mode" [userTypeLabelKey]="'driver'"
               [create]="onCreate" [update]="onUpdate"
               [remove]="onDelete" [block]="onToggleBlocking"
               [unblockIp]="onUnblockIp"
               (changePassword)="changePassword($event)"
               (afterCreate)="goToDriverList()"
               (afterDelete)="goToDriverList()"
>
</app-user-form>
